export class ProviderAddOrganizationRequest {
    organizationId: string;
    key: string;
}
